import { createContext } from 'react';
const stub = () => {
    throw new Error('You forgot to wrap your component in <MenuContext.Provider />.');
};
export const MenuContext = createContext({
    opened: false,
    getTriggerProps: stub,
    triggerRef: stub,
    placement: undefined,
});
